export default Object.freeze({
	About: [{ name: '.', link: '.' }],
	Contacts: [{ name: '.', link: '.' }],
	/* CookiePolicy: [{ name: '.', link: '.' }], */
	CreditsList: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'CreditsList', link: '.' },
	],
	Dashboard: [{ name: '.', link: '.' }],
	FaqLawyer: [{ name: '.', link: '.' }],
	FaqUser: [{ name: '.', link: '.' }],
	FeedbacksList: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'FeedbacksList', link: '.' },
	],
	HowToLawyer: [{ name: '.', link: '.' }],
	HowToUser: [{ name: '.', link: '.' }],
	MessagesList: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'MessagesList', link: '.' },
	],
	NewsletterUnsubscribe: [{ name: '.', link: '.' }],
	Partners: [{ name: '.', link: '.' }],
	Pricing: [{ name: '.', link: '.' }],
	/* Privacy: [{ name: '.', link: '.' }], */
	Profile: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: '.', link: '.' },
	],
	ProfileInfo: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'Profile', link: 'profile' },
		{ name: '.', link: '.' },
	],
	ProfileNotifications: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'Profile', link: 'profile' },
		{ name: '.', link: '.' },
	],
	ProfilePreferences: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'Profile', link: 'profile' },
		{ name: '.', link: '.' },
	],
	ProfileSecurity: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'Profile', link: 'profile' },
		{ name: '.', link: '.' },
	],
	RequestTypesList: [{ name: 'RequestTypesList', link: '.' }],
	'RequestTypesDetail.altre-risarcitorie': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.altre-risarcitorie', link: '.' },
	],
	'RequestTypesDetail.cause-condominiali': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.cause-condominiali', link: '.' },
	],
	'RequestTypesDetail.cause-di-lavoro': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.cause-di-lavoro', link: '.' },
	],
	'RequestTypesDetail.contenziosi-commerciali': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.contenziosi-commerciali', link: '.' },
	],
	'RequestTypesDetail.contenziosi-fiscali-e-tributari': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.contenziosi-fiscali-e-tributari', link: '.' },
	],
	'RequestTypesDetail.contratti-assicurativi': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.contratti-assicurativi', link: '.' },
	],
	'RequestTypesDetail.contratti-bancari-e-finanziari': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.contratti-bancari-e-finanziari', link: '.' },
	],
	'RequestTypesDetail.contratti-di-locazione': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.contratti-di-locazione', link: '.' },
	],
	'RequestTypesDetail.diffamazione-a-mezzo-stampa': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.diffamazione-a-mezzo-stampa', link: '.' },
	],
	'RequestTypesDetail.divisioni-immobiliari': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.divisioni-immobiliari', link: '.' },
	],
	'RequestTypesDetail.danno-da-vacanza-rovinata': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.danno-da-vacanza-rovinata', link: '.' },
	],
	'RequestTypesDetail.lesioni-personali': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.lesioni-personali', link: '.' },
	],
	'RequestTypesDetail.malasanita': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.malasanita', link: '.' },
	],
	'RequestTypesDetail.parte-civile-in-processi-penali': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.parte-civile-in-processi-penali', link: '.' },
	],
	'RequestTypesDetail.recupero-crediti': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.recupero-crediti', link: '.' },
	],
	'RequestTypesDetail.ricorsi-inps': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.ricorsi-inps', link: '.' },
	],
	'RequestTypesDetail.sinistri-stradali': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.sinistri-stradali', link: '.' },
	],
	'RequestTypesDetail.successioni-ereditarie': [
		{ name: 'RequestTypesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.successioni-ereditarie', link: '.' },
	],
	RequestCreateStep1: [{ name: 'RequestCreateStep1', link: '.' }],
	RequestCreateStep2: [{ name: 'RequestCreateStep2', link: '.' }],
	RequestCreateStep3: [{ name: 'RequestCreateStep3', link: '.' }],
	RequestCreateStep4: [{ name: 'RequestCreateStep4', link: '.' }],
	RequestCreateStep5: [{ name: 'RequestCreateStep5', link: '.' }],
	RequestCreateStep6: [{ name: 'RequestCreateStep6', link: '.' }],
	RequestCreateStep7: [{ name: 'RequestCreateStep7', link: '.' }],
	RequestCreateStep8: [{ name: 'RequestCreateStep8', link: '.' }],
	RequestCreateStep9: [{ name: 'RequestCreateStep9', link: '.' }],
	RequestsDetailUser: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'RequestsListUser', link: 'requestsList' },
		{ name: 'RequestsDetailUser', link: '.' },
	],
	RequestsListLawyer: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'RequestsListLawyer', link: '.' },
	],
	RequestsListUser: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'RequestsListUser', link: '.' },
	],
	ResponsesDetailLawyer: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'ResponsesListLawyer', link: 'responsesList' },
		{ name: 'ResponsesDetailLawyer', link: '.' },
	],
	ResponsesDetailUser: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'RequestsListUser', link: 'requestsList' },
		{ name: 'ResponsesDetailUser', link: '.' },
	],
	ResponsesListLawyer: [
		{ name: 'Dashboard', link: 'dashboard' },
		{ name: 'ResponsesListLawyer', link: '.' },
	],
	RegisterLawyer: [{ name: '.', link: '.' }],
	RegisterUser: [{ name: '.', link: '.' }],
	RegisterUserFindALawyer: [{ name: 'RegisterUserFindALawyer', link: '.' }],
	'StoriesDetail.altre-risarcitorie': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.altre-risarcitorie',
			link: 'requestTypesDetail',
			params: { code: 'altre-risarcitorie' },
		},
		{ name: 'StoriesDetail.altre-risarcitorie', link: '.' },
	],
	'StoriesDetail.cause-condominiali': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.cause-condominiali',
			link: 'requestTypesDetail',
			params: { code: 'cause-condominiali' },
		},
		{ name: 'StoriesDetail.cause-condominiali', link: '.' },
	],
	'StoriesDetail.cause-di-lavoro': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.cause-di-lavoro', link: 'requestTypesDetail', params: { code: 'cause-di-lavoro' } },
		{ name: 'StoriesDetail.cause-di-lavoro', link: '.' },
	],
	'StoriesDetail.contenziosi-commerciali': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.contenziosi-commerciali',
			link: 'requestTypesDetail',
			params: { code: 'contenziosi-commerciali' },
		},
		{ name: 'StoriesDetail.contenziosi-commerciali', link: '.' },
	],
	'StoriesDetail.contenziosi-fiscali-e-tributari': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.contenziosi-fiscali-e-tributari',
			link: 'requestTypesDetail',
			params: { code: 'contenziosi-fiscali-e-tributari' },
		},
		{ name: 'StoriesDetail.contenziosi-fiscali-e-tributari', link: '.' },
	],
	'StoriesDetail.contratti-assicurativi': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.contratti-assicurativi',
			link: 'requestTypesDetail',
			params: { code: 'contratti-assicurativi' },
		},
		{ name: 'StoriesDetail.contratti-assicurativi', link: '.' },
	],
	'StoriesDetail.contratti-bancari-e-finanziari': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.contratti-bancari-e-finanziari',
			link: 'requestTypesDetail',
			params: { code: 'contratti-bancari-e-finanziari' },
		},
		{ name: 'StoriesDetail.contratti-bancari-e-finanziari', link: '.' },
	],
	'StoriesDetail.contratti-di-locazione': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.contratti-di-locazione',
			link: 'requestTypesDetail',
			params: { code: 'contratti-di-locazione' },
		},
		{ name: 'StoriesDetail.contratti-di-locazione', link: '.' },
	],
	'StoriesDetail.diffamazione-a-mezzo-stampa': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.diffamazione-a-mezzo-stampa',
			link: 'requestTypesDetail',
			params: { code: 'diffamazione-a-mezzo-stampa' },
		},
		{ name: 'StoriesDetail.diffamazione-a-mezzo-stampa', link: '.' },
	],
	'StoriesDetail.divisioni-immobiliari': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.divisioni-immobiliari',
			link: 'requestTypesDetail',
			params: { code: 'divisioni-immobiliari' },
		},
		{ name: 'StoriesDetail.divisioni-immobiliari', link: '.' },
	],
	'StoriesDetail.lesioni-personali': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.lesioni-personali', link: 'requestTypesDetail', params: { code: 'lesioni-personali' } },
		{ name: 'StoriesDetail.lesioni-personali', link: '.' },
	],
	'StoriesDetail.malasanita': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.malasanita', link: 'requestTypesDetail', params: { code: 'malasanita' } },
		{ name: 'StoriesDetail.malasanita', link: '.' },
	],
	'StoriesDetail.parte-civile-in-processi-penali': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.parte-civile-in-processi-penali',
			link: 'requestTypesDetail',
			params: { code: 'parte-civile-in-processi-penali' },
		},
		{ name: 'StoriesDetail.parte-civile-in-processi-penali', link: '.' },
	],
	'StoriesDetail.recupero-crediti': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.recupero-crediti', link: 'requestTypesDetail', params: { code: 'recupero-crediti' } },
		{ name: 'StoriesDetail.recupero-crediti', link: '.' },
	],
	'StoriesDetail.sinistri-stradali': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{ name: 'RequestTypesDetail.sinistri-stradali', link: 'requestTypesDetail', params: { code: 'sinistri-stradali' } },
		{ name: 'StoriesDetail.sinistri-stradali', link: '.' },
	],
	'StoriesDetail.successioni-ereditarie': [
		{ name: 'StoriesList', link: 'requestTypesList' },
		{
			name: 'RequestTypesDetail.successioni-ereditarie',
			link: 'requestTypesDetail',
			params: { code: 'successioni-ereditarie' },
		},
		{ name: 'StoriesDetail.successioni-ereditarie', link: '.' },
	],
	TermsAndConditions: [{ name: '.', link: '.' }],
})



// WEBPACK FOOTER //
// ./src/breadcrumbs.js